
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class TaxRateGrid extends Serenity.EntityGrid<TaxRateRow, any> {
        protected getColumnsKey() { return TaxRateColumns.columnsKey; }
        protected getDialogType() { return TaxRateDialog; }
        protected getIdProperty() { return TaxRateRow.idProperty; }
        protected getInsertPermission() { return TaxRateRow.insertPermission; }
        protected getLocalTextPrefix() { return TaxRateRow.localTextPrefix; }
        protected getService() { return TaxRateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);


            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: TaxRateService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));






            return buttons;
        }
    }
}